var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-file-input',{attrs:{"multiple":"","show-size":"","label":"Bilder auswählen"},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}}),_c('v-btn',{attrs:{"disabled":!_vm.files || !_vm.files.length,"color":"primary","loading":_vm.loading},on:{"click":_vm.upload}},[_vm._v("Hochladen")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }